import { useEffect, useState } from 'react';
import { Input } from 'antd';
import { Search } from 'lucide-react';

/** 凭证名称搜索框，输入停止 300ms 后回调 */
export default function CredentialNameSearch({ onSearch }: { onSearch: (name: string) => void }) {
  const [draft, setDraft] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => onSearch(draft.trim()), 300);
    return () => clearTimeout(timer);
  }, [draft, onSearch]);

  return (
    <Input
      placeholder="搜索名称"
      allowClear
      prefix={<Search size={14} />}
      style={{ width: 200 }}
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
    />
  );
}
